module.exports = __webpack_public_path__ + "img/img_gongshi.32f798c4.png";